import React from 'react';
import { ReduxFormButtonGroup } from './ReduxFormButtonGroup';
import { makeButtonGroupOptionsFromEnum } from 'Common/FormHelper';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

const options = makeButtonGroupOptionsFromEnum(reportFormatEnum);

const ReportFormatButtonGroup = props => {
  return <ReduxFormButtonGroup options={options} {...props} />;
};

export { ReportFormatButtonGroup };



// WEBPACK FOOTER //
// ./src/components/forms/ReportFormatButtonGroup.js